import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[numberWheel]',
    standalone: false
})
export class NumberWheelDirective {

    @HostListener('wheel', ['$event'])
    onWheel(event: WheelEvent) {
        const input = event.target as HTMLInputElement;

        if (document.activeElement !== input) {
            return;
        }

        if (input.disabled || input.readOnly) return;

        event.preventDefault();
        event.stopPropagation();
    }
}